import request from '../tools/request'
import { HTTP } from './http'

const { GET, POST, downFilePost } = request

// 发票管理模块api

/**
 * 可开红票明细导出 (退货单维度)
 * @param params 退货单id列表（逗号分隔）
 * @returns 导出文件
 */
export const EXPORT_RED_INVOICE_DETAIL = (params: { returnOrderIds: string }) =>
  request.downFileGET(`${HTTP}/input/invoice/exportRedInvoiceDetail`, params)

/**
 * 导出红票寄票随单
 * @param returnOrderIds 退货单id数组
 * @returns 导出PDF文件
 */
export const DOWNLOAD_RED_ACCEPT_TEMP = (returnOrderIds: string[]) =>
  downFilePost(
    `${HTTP}/input/invoice/downloadRedAcceptTemp`,
    returnOrderIds,
    'application/json',
  )
import request from '../tools/request'
import { HTTP } from './http'

const { GET, POST, downFilePost } = request

// 发票管理模块api

/**
 * 可开红票明细导出 (退货单维度)
 * @param params 退货单id列表（逗号分隔）
 * @returns 导出文件
 */
export const EXPORT_RED_INVOICE_DETAIL = (params: { returnOrderIds: string }) =>
  request.downFileGET(`${HTTP}/input/invoice/exportRedInvoiceDetail`, params)

/**
 * 导出红票寄票随单
 * @param returnOrderIds 退货单id数组
 * @returns 导出PDF文件
 */
export const DOWNLOAD_RED_ACCEPT_TEMP = (returnOrderIds: string[]) =>
  downFilePost(
    `${HTTP}/input/invoice/downloadRedAcceptTemp`,
    returnOrderIds,
    'application/json',
  )
